// extracted by css-extract-rspack-plugin
export default {"cls1":"Timer-cls1_p-m","cls2":"Timer-cls2_jMx Timer-cls1_p-m","withoutHours":"Timer-withoutHours_Beu","mini":"Timer-mini_JOs"};